import styled from 'styled-components';

export const CardWrapper = styled.div`
  background: #ffffff;
  border-radius: 14px;
  padding: 16px;
  margin: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f0f0;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
`;

export const Title = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
`;

export const Description = styled.div`
  font-size: 12px;
  color: #666666;
  margin: 0 0 12px 0;
`;

export const StatusIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #137333;
  font-weight: 500;
  margin-bottom: 12px;
  background: #e6f4ea;
  padding: 6px 10px;
  border-radius: 8px;
  width: fit-content;

  span {
    width: 7px;
    height: 7px;
    background: #34a853;
    border-radius: 50%;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 8px;
`;
